import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Check } from '../Img/icon-check.svg';

const purple = '#6571FE';
const green = '#59B44A';

const Nn1n2 = (props) =>
{
    const [aff, setAff] = useState(false)
    const [n, setN] = useState('0')
    const [n_1, setN_1] = useState('0')
    const [n_2, setN_2] = useState('0')
    const [tauxAnnuels, setTauxAnnuels] = useState([])

    const isAdmin = props.user?.id_type_users == '1' || props.user?.id_type_users == '2';

    useEffect(() => {
        if (props.budget) {
            setN(props.budget['n'])
            setN_1(props.budget['n-1'])
            setN_2(props.budget['n-2'])
            setAff(!aff)
            
            // Charger les taux annuels
            loadTauxAnnuels();
        }
    }, [props.budget])

    async function loadTauxAnnuels() {
        axios.post("https://app-slfinance.fr/api/taux_fctva.php", qs.stringify({
            'get': true,
            'id_budget': props.budget.id
        }))
        .then((res) => {
            let completeData = [];
            if (res.data && res.data.length > 0) {
                const sortedData = res.data.sort((a, b) => parseInt(a[0]) - parseInt(b[0]));
                
                for (let year = parseInt(props.user.config_budget.prosp_an_deb); year <= parseInt(props.user.config_budget.prosp_an_fin); year++) {
                    const existing = sortedData.find(item => parseInt(item[0]) === year);
                    if (existing) {
                        completeData.push(existing);
                    } else {
                        completeData.push([year, '0']);
                    }
                }
            } else {
                for (let year = parseInt(props.user.config_budget.prosp_an_deb); year <= parseInt(props.user.config_budget.prosp_an_fin); year++) {
                    completeData.push([year, '0']);
                }
            }
            
            setTauxAnnuels(completeData);
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    async function validation(data)
    {
        await setN('0')
        await setN_1('0')
        await setN_2('0')
        const params = {
            'updateBudget': true,
            'id_budget': props.budget.id,
            'n': '0',
            'n_1': '0',
            'n_2': '0'
        }
        if (data === 'n') {
            await setN('1')
            params['n'] = '1'
        }
        if (data === 'n-1') {
            await setN_1('1')
            params['n_1'] = '1'
        }
        if (data === 'n-2') {
            await setN_2('1')
            params['n_2'] = '1'
        }

        await axios.post("https://app-slfinance.fr/api/budgets.php", qs.stringify(params))
        .catch((err) => {
            console.warn(err)
        })
        await setAff(!aff)
    }

    const handleTauxChange = (year, value) => {
        var tmp = [...tauxAnnuels];
        tmp = tmp.map(element => {
            if (parseInt(element[0]) === parseInt(year)) {
                return [element[0], value];
            }
            return element;
        });
        setTauxAnnuels(tmp);
        setAff(!aff);
    };

    const saveChanges = () => {
        var tmp = tauxAnnuels.map(elem => [parseInt(elem[0]), elem[1]]);
        axios.post("https://app-slfinance.fr/api/taux_fctva.php", qs.stringify({
            'update': true,
            'id_budget': props.budget.id,
            'objet': tmp
        }))
        .then((res) => {
            if (res.data['status'] === 1) {
                NotificationManager.success(res.data['status_message'], '', 500);
            }
            else {
                NotificationManager.warning(res.data['status_message'], '', 3000);
            }
        })
        .catch((err) => {
            console.warn(err)
            NotificationManager.error('Erreur lors de la sauvegarde', '', 3000);
        })
    }

    const years = [
        { label: 'n',   value: n,   onClick: () => validation('n') },
        { label: 'n-1', value: n_1, onClick: () => validation('n-1') },
        { label: 'n-2', value: n_2, onClick: () => validation('n-2') },
    ];

	return (
        <div className='shadow-md' style={{borderRadius: 8, padding: 20, backgroundColor: 'white'}}>

            {props.budget && (
                <div>
                    {/* Année de référence */}
                    <div>
                        <p style={{fontWeight: 'bold', fontSize: 12, marginBottom: 8, textTransform: 'uppercase', textAlign: 'center'}}>
                            Sélectionnez l'année de référence des dépenses d'équipement pour le calcul du FCTVA
                        </p>
                    </div>
                    <div style={{display: 'flex', gap: 8, marginBottom: 20}}>
                        <div style={{flex: 7}}></div>
                        {years.map(({ label, value, onClick }) => (
                            <button
                                key={label}
                                onClick={isAdmin ? onClick : undefined}
                                disabled={!isAdmin}
                                style={{
                                    flex: 1,
                                    marginLeft: 10,
                                    marginRight: 10,
                                    padding: '10px 8px',
                                    borderRadius: 6,
                                    border: `2px solid ${value !== '0' ? purple : '#E5E7EB'}`,
                                    backgroundColor: value !== '0' ? '#EEEFFE' : '#F9FAFB',
                                    color: value !== '0' ? purple : '#6B7280',
                                    fontWeight: value !== '0' ? '700' : '400',
                                    cursor: isAdmin ? 'pointer' : 'default',
                                    fontSize: 14,
                                    transition: 'all 0.15s'
                                }}
                            >
                                {label}
                            </button>
                        ))}
                        <div style={{flex: 7}}></div>
                    </div>

                    {/* Tableau Taux annuels */}
                    <p style={{fontWeight: 'bold', fontSize: 12, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: 20}}>
                        Saisir le taux du FCTVA applicable à chaque année
                    </p>

                    {/* En-têtes du tableau */}
                    <div style={{display: 'flex', marginBottom: 10, borderBottom: `2px solid ${purple}`, paddingBottom: 10, justifyContent: 'center'}}>
                        <div style={{flex: 0.3, fontWeight: 'bold', color: purple, textAlign: 'center'}}>Année</div>
                        <div style={{flex: 0.7, fontWeight: 'bold', color: purple, textAlign: 'center'}}>Taux FCTVA (%)</div>
                    </div>

                    {/* Contenu du tableau */}
                    <div style={{flex: 1, maxHeight: 300, overflowY: 'auto'}}>
                        {tauxAnnuels && tauxAnnuels.length > 0 ?
                        tauxAnnuels.map((annee, index) =>
                        <div key={annee[0]} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px 0', borderBottom: `1px solid #E9ECEF`, backgroundColor: index % 2 === 0 ? '#FAFAFA' : 'white'}}>
                            <div style={{flex: 0.3, fontSize: 14, textAlign: 'center'}}>
                                <p style={{margin: 0, fontWeight: 'bold'}}>{annee[0]}</p>
                            </div>
                            
                            <div style={{flex: 0.7, textAlign: 'center'}}>
                                <input 
                                    disabled={!isAdmin}
                                    style={{
                                        width: '100%',
                                        maxWidth: 120, 
                                        border: `1px solid ${isAdmin ? '#E9ECEF' : '#E5E7EB'}`, 
                                        borderRadius: 5, 
                                        padding: '8px 12px',
                                        fontSize: 14,
                                        textAlign: 'center',
                                        backgroundColor: isAdmin ? 'white' : '#F9FAFB',
                                        color: '#374151'
                                    }} 
                                    placeholder={parseFloat(annee[1])+ "%"} 
                                    onBlur={(e) => {
                                        if (e.target.value !== '' && !isNaN(parseFloat(e.target.value))) {
                                            handleTauxChange(annee[0], e.target.value)
                                        }
                                        e.target.value = '';
                                    }}
                                />
                            </div>
                        </div>
                        ):
                        <div style={{padding: 20, textAlign: 'center', color: '#999'}}>
                            <p>Aucun taux trouvé</p>
                        </div>
                        }
                    </div>

                    {isAdmin && (
                    <div style={{margin: 20, marginTop: 30, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                        <button 
                            onClick={saveChanges}
                            style={{display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, paddingLeft: 10, cursor: 'pointer', border: 'none', padding: '8px 15px', alignItems: 'center'}}
                        >
                            <Check width="12" />
                            <span style={{marginLeft: 5, fontSize: 14, paddingRight: 10}}>Valider</span>
                        </button>
                    </div>
                    )}
                </div>
            )}

        </div>
	);
}

export default Nn1n2;
